// extracted by mini-css-extract-plugin
module.exports = {"root":"BrowserAppHelp_root__tKnh7","tutorial":"BrowserAppHelp_tutorial__zFsfS"};